
<div class="input-group input-group-lg mb-2">
    <input class="form-control" type="text" placeholder="Søk" [(ngModel)]="filterParams.tekst" (keyup)="filterChanged($event)"
        name="tekstFilter">
</div>
